
/*----------------------
   ANIMATED PRODUCTS
---------------------- */
AnimatedProducts = {
    init: function () {
        if ($(".section-animated-products").length && typeof gsap !== "undefined") {
            var directions = [
                { x: 14, y: -10 },
                { x: -12, y: -14 },
                { x: 16, y: 8 },
                { x: -10, y: 12 },
                { x: 8, y: -16 },
                { x: -16, y: 6 },
                { x: 12, y: 14 },
                { x: -8, y: -12 },
                { x: 18, y: -4 },
                { x: -14, y: 10 },
                { x: 6, y: 16 },
                { x: -18, y: -8 },
            ];

            $(".animated-products__item").each(function (index) {
                var direction = directions[index % directions.length];
                var duration = 1.4 + (index % 5) * 0.15;
                var delay = (index % 6) * 0.12;
                var rotate = index % 2 === 0 ? 3 : -3;

                gsap.to(this, {
                    x: direction.x,
                    y: direction.y,
                    rotation: rotate,
                    duration: duration,
                    delay: delay,
                    ease: "sine.inOut",
                    yoyo: true,
                    repeat: -1,
                });
            });
        }
    },
};

$(document).ready(function () {
    AnimatedProducts.init();
});
